<template>
  <div :class="['countdownTimer', `format-${this._format}`]" data-testid="sbx-pcc_countdownTimer" ref="timer" :style="cssProps">
    <div class="countdownTimer__block">
      <div class="countdownTimer__count">{{ displayDays }}</div>
      <div class="countdownTimer__label">{{ $t('days') }}</div>
    </div>
    <div class="countdownTimer__block">
      <div class="countdownTimer__count">{{ displayHours }}</div>
      <div v-if="this._format === 'block'" class="countdownTimer__label">{{ $t('hours') }}</div>
    </div>
    <div v-if="this._format === 'inline'" class="separator">:</div>
    <div class="countdownTimer__block">
      <div class="countdownTimer__count">{{ displayMinutes }}</div>
      <div v-if="this._format === 'block'" class="countdownTimer__label">{{ $t('minutes') }}</div>
    </div>
    <div v-if="this._format === 'inline'" class="separator">:</div>
    <div class="countdownTimer__block">
      <div class="countdownTimer__count">{{ displaySeconds }}</div>
      <div v-if="this._format === 'block'" class="countdownTimer__label">{{ $t('seconds') }}</div>
    </div>
  </div>
</template>

<script>
import { countdownTimer } from './index.js';

export default {
  name: 'countdownTimer',
  props: {
    ...countdownTimer.propTypes,
    format: String,
  },
  data() {
    return {
      displayDays: 0,
      displayHours: 0,
      displayMinutes: 0,
      displaySeconds: 0,
      loading: false,
    };
  },

  computed: {
    _seconds: () => 1000,
    _minutes() {
      return this._seconds * 60;
    },
    _hours() {
      return this._minutes * 60;
    },
    _days() {
      return this._hours * 24;
    },
    end() {
      return new Date(parseInt(this.year), parseInt(this.month) - 1, parseInt(this.day), parseInt(this.hour), parseInt(this.minute));
    },
    _format() {
      return this.format || 'block';
    },
    cssProps() {
      return {
        '--textColor': this.color ? this.color : countdownTimer.propTypes.color.default,
        '--bgColor': this.bgColor ? this.bgColor : countdownTimer.propTypes.bgColor.default,
      };
    },
    getWidth() {
      return this.$refs.timer.clientWidth;
    },
  },

  mounted() {
    this.showRemainingTime();
  },

  methods: {
    formatNum(num) {
      return num < 10 ? '0' + num : num;
    },

    showRemainingTime() {
      const timer = setInterval(() => {
        const now = new Date();
        const distance = this.end.getTime() - now.getTime();

        if (distance < 0) {
          clearInterval(timer);
          return;
        }

        const days = Math.floor(distance / this._days);
        const hours = Math.floor((distance % this._days) / this._hours);
        const minutes = Math.floor((distance % this._hours) / this._minutes);
        const seconds = Math.floor((distance % this._minutes) / this._seconds);

        this.displayMinutes = this.formatNum(minutes, this._format);
        this.displaySeconds = this.formatNum(seconds, this._format);
        this.displayHours = this.formatNum(hours, this._format);
        this.displayDays = this.formatNum(days, this._format);
      }, 1000);
    },
  },
};
</script>
<style lang="scss" scoped>
@import '@/SharedFe/scss/variables.scss';

$small-only: 'only screen and (max-width: 767px)';
$medium-only: 'only screen and (min-width: 768px) and (max-width: 1024px)';
$medium-up: 'only screen and (min-width: 768px)';
$large-up: 'only screen and (min-width: 1025px)';

$textColor: var(--textColor);
$bgColor: var(--bgColor);

.countdownTimer {
  display: flex;
  justify-content: center;
  overflow: hidden;

  &__block {
    margin: 0.5rem;
    padding: rem-calc(20);
    text-align: justify;
    border-radius: rem-calc(2);
    min-width: rem-calc(120);
    background-color: $bgColor;
  }

  &__count {
    text-align: center;
    font-family: $brand-font-bold;
    font-size: rem-calc(40);
    color: $textColor;
  }

  &__label {
    text-align: center;
    text-transform: uppercase;
    font-size: rem-calc(16);
    color: $textColor;
  }

  @media #{$small-only} {
    display: grid;
    gap: rem-calc(8);
    grid-auto-flow: column;
    grid-auto-columns: 1fr;
    grid-template-columns: minmax(min-content, 1fr);
    margin: rem-calc(12) 0 1rem;
    &__block {
      margin: 0;
      padding: rem-calc(12) rem-calc(14);
      min-width: auto;
      max-height: 100%;
    }
    &__count {
      font-size: rem-calc(20);
      line-height: rem-calc(20);
    }
    &__label {
      font-size: rem-calc(8);
      line-height: rem-calc(10);
      padding-left: rem-calc(5);
    }
  }
}

.countdownTimer.format-inline {
  width: rem-calc(180);
  margin: 0 auto;
  justify-content: left;
  padding: rem-calc(3 0);

  .countdownTimer__block {
    display: flex;
    margin: 0;
    padding: 0;
    min-width: 0;
    background-color: transparent;
    font-family: $brand-font-bold;
  }

  .countdownTimer__count {
    font-size: rem-calc(19);
  }

  .countdownTimer__label {
    font-size: rem-calc(19);
    text-transform: none;
    font-family: $brand-font-regular;
    padding: rem-calc(0 5);
  }

  .separator {
    padding: rem-calc(0 2);
    color: $textColor;
    font-family: $brand-font-bold;
  }

  @media #{$small-only} {
    display: flex;
    gap: initial;
    margin: 0 auto;
    & .countdownTimer__label,
    .countdownTimer__count {
      line-height: inherit;
    }
  }
}
</style>
